module.exports = __webpack_public_path__ + "img/details.f4c49c17.svg";